<template>
  <div class="room"> 
    <Row :gutter="20">
      <Col span="14">
      <roomInfo></roomInfo>
      <div class="gap"></div>
      <roomRole></roomRole>
      </Col>

      <Col span="10">
      <roomPush></roomPush>
      <div class="gap"></div>
      <roomProduct></roomProduct>
      </Col>
    </Row>
    <div class="loading" v-if="loading">
      <Spin fix>
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>
    <div class="empty" v-if="empty">
      暂无直播间数据
    </div>

  </div>
</template>

<script>
import roomInfo from "./components/room-info.vue";
import roomProduct from "./components/room-product.vue";
import roomPush from "./components/room-push.vue";
import roomRole from "./components/room-role.vue"; 
export default {
  name: "host-activity-live-set",
  components: {
    roomInfo,
    roomProduct,
    roomPush,
    roomRole, 
  },
  data () {
    return {
      loading: false,
      empty: false,
      // roomData: null,
    };
  },
  computed: {
    channelId () {
      return this.$route.query.channelId;
    },
  },
  methods: {
    // ...mapActions({
    //   channelQuery: 'liveModule/channelQuery',
    // }),
    // async init () {
    //   if (!this.channelId) return;
    //   let res = await this.channelQuery(this.channelId);
    //   console.log('channelQuery', res);
    //   if (res.code === 200 && res.status === 'success') {
    //     this.roomData = res.data;
    //   }
    // }
  },
  created () {
    // this.init();
  },
  mounted () {
  }
}

</script>

<style lang="scss" scoped>
.room {
  min-width: 900px;
  margin: 24px;
}

.gap {
  height: 15px;
  width: 100%;
}

.empty {
  font-size: 18px;
  font-weight: bold;
  height: 400px;
  background-color: #ffff;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin: 20px;
}
</style>
